<template>
  <div
    class="popBox"
    v-if="isBox"
  >
    <div class="box">
      <div class="header"></div>
      <div class="tishi">
        <p>
          <img
            src="../../assets/course/tishi.png"
            alt=""
          >
          <span>提示</span>
        </p>
        <div
          class="close"
          @click="$emit('closemodal')"
        >X</div>
      </div>
      <div class="content">
        <p>您没有权限，请先开通权限。</p>
        <button
          class="addbtn"
          @click="$emit('closemodal')"
        >确认</button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "popBox",
  props: {
    isBox: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
.popBox {
  position: relative;
  z-index: 999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.5);

  .box {
    width: 489px;
    height: 246px;
    background-color: #ffffff;
    border-radius: 3px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .header {
    width: 100%;
    height: 5px;
    background-color: #0096ff;
  }

  .tishi {
    p {
      margin: 0 auto;
      width: 420px;
      border-bottom: 1px solid #dfdfdf;
      height: 70px;
      line-height: 70px;
      display: flex;
      align-items: center;
      position: relative;

      span:nth-child(1) {
        width: 32px;
        height: 33px;
        color: #fff;
        display: block;
        border-radius: 50%;
        font-size: 20px;
        text-align: center;
        background-color: #0096ff;
        line-height: 33px;
      }

      span:nth-child(2) {
        color: #666666;
        font-size: 18px;
        padding-left: 11px;
      }
    }

    .close {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      color: #999;
      font-size: 22px;
      position: absolute;
      right: 15px;
      top: 15px;
      cursor: pointer;
    }
  }

  .content {
    p {
      width: 420px;
      margin: 0 auto;
      padding-top: 40px;
      font-size: 16px;
    }

    .addbtn {
      width: 108px;
      height: 36px;
      background-color: #f0cd48;
      border-radius: 3px;
      color: #fff;
      border: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      outline: none;
      font-size: 16px;
      position: absolute;
      right: 35px;
      bottom: 25px;
    }
  }
}
</style>
